import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {jwtInterceptor} from './auth/jwt-interceptor';
import {RxStompService} from '@stomp/ng2-stompjs';
import {myRxStompConfig} from './my-rx-stomp.config';
import {registerLocaleData} from '@angular/common';
import localeIt from '@angular/common/locales/it';
import {provideAnimations} from '@angular/platform-browser/animations';
import {providePrimeNG} from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import {networkRetryInterceptor} from './auth/network-retry-interceptor';

registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top'
      }),
      withPreloading(PreloadAllModules)
    ),
    provideHttpClient(
      withInterceptors([jwtInterceptor, networkRetryInterceptor])
    ),
    {
      provide: RxStompService,
      useFactory: () => {
        const rxStomp = new RxStompService();
        rxStomp.configure(myRxStompConfig)
        return rxStomp;
      }
    },
    { provide: LOCALE_ID, useValue: 'it-IT' },
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities'
          }
        }
      },
      translation: {
        emptyFilterMessage: 'Nessun risultato trovato',
        emptyMessage: 'Nessuna opzione disponibile',
        dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
        dayNamesMin: ["D", "L", "M", "M", "G", "V", "S"],
        monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
        monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
        today: 'Oggi',
        clear: 'Pulisci'
      }
    })
  ]
};
